import React from 'react';
import './header.css';

class Header extends React.Component {
  render() {
    const data = require('../../other.json');
    return (
      <div className="header">
        <a
          className="link"
          href="https://museum.ok.ru/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <div className="header__element">
            <img className="header__ok-logo" src="./images/ok-logo_white.svg" alt="Логотип сайта «Одноклассники»" />
            <div className="header__title">Мы в музей</div>
          </div>
        </a>
        <a
          className="link"
          href={data.header.linkLogo}
          rel="noopener noreferrer"
          target="_blank"
        >
          {/* <div className="header__logo-container">
            <img className="header__museum-logo" src={data.header.localPath} alt="Логотип музея" />
          </div> */}
        </a>
      </div>
    );
  }
}

export default Header;
